import React, { useState, useEffect, useRef } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import "./inputDropdown.scss";
import InputCheckbox from "../inputCheckbox/inputCheckbox";

const InputDropdown = ({
    options,
    onSelect,
    value = [],
    placeholder = "Selecciona una opción",
    label = "Label",
    showLabel = true,
    withCheckboxes = false,
    hasSearch = false,
    required = false,
}) => {
    const [inputValue, setInputValue] = useState(value?.label || "");
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOptions, setSelectedOptions] = useState(value);
    const [searchTerm, setSearchTerm] = useState("");
    const dropdownRef = useRef(null);

    useEffect(() => {
        if (!isOpen) {
            setSearchTerm("");
        }
    }, [isOpen]);

    const handleInputClick = () => {
        setIsOpen((prev) => !prev);
    };

    const handleOptionClick = (option) => {
        if (withCheckboxes) {
            const isAlreadySelected = selectedOptions.includes(option.value);
            const newSelection = isAlreadySelected
                ? selectedOptions.filter((o) => o !== option.value)
                : [...selectedOptions, option.value];

            setSelectedOptions(newSelection);
            onSelect(newSelection);
        } else {
            setInputValue(option.label);
            onSelect(option);
            setIsOpen(false);
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target)
            ) {
                setIsOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

const filteredOptions =
    hasSearch && isOpen
        ? options.filter((option) =>
              (option.label || "")
                  .toLowerCase()
                  .includes(searchTerm.toLowerCase())
          )
        : options;


    return (
        <div className="input-dropdown" ref={dropdownRef}>
            {showLabel && (
                <label className="input-dropdown__label">
                    {label}
                    {required && (
                        <span className="input-dropdown__required">*</span>
                    )}
                </label>
            )}
            <div className="input-dropdown__wrapper">
                <input
                    type="text"
                    value={
                        isOpen && hasSearch
                            ? searchTerm
                            : withCheckboxes
                            ? selectedOptions
                                  .map(
                                      (val) =>
                                          options.find(
                                              (opt) => opt.value === val
                                          )?.label
                                  )
                                  .filter(Boolean)
                                  .join(", ")
                            : inputValue
                    }
                    onChange={
                        isOpen && hasSearch
                            ? (e) => setSearchTerm(e.target.value)
                            : undefined
                    }
                    readOnly={!(isOpen && hasSearch)}
                    onClick={handleInputClick}
                    placeholder={placeholder}
                    className={`input-dropdown__input ${
                        isOpen ? "input-dropdown__input--open" : ""
                    }`}
                    required={required}
                />
                <span className="input-dropdown__icon">
                    {isOpen ? <FaChevronUp /> : <FaChevronDown />}
                </span>
            </div>
            {isOpen && (
                <ul
                    className="input-dropdown__list"
                    onMouseDown={(e) => e.preventDefault()}
                >
                    {filteredOptions.length > 0 ? (
                        filteredOptions.map((option, index) => (
                            <li
                                key={index}
                                className="input-dropdown__list-item"
                            >
                                {withCheckboxes ? (
                                    <InputCheckbox
                                        checked={selectedOptions.includes(
                                            option.value
                                        )}
                                        onChange={() =>
                                            handleOptionClick(option)
                                        }
                                        label={option.label}
                                    />
                                ) : (
                                    <div
                                        onClick={() =>
                                            handleOptionClick(option)
                                        }
                                    >
                                        {option.label}
                                    </div>
                                )}
                            </li>
                        ))
                    ) : (
                        <li className="input-dropdown__list-item">
                            No se han encontrado opciones
                        </li>
                    )}
                </ul>
            )}
        </div>
    );
};

export default InputDropdown;
